import React, {useState, useEffect, useRef} from 'react';
import {blue, green, purple} from "@material-ui/core/colors";
import {makeStyles} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import clsx from 'clsx';
import {
    checkuser,
    getsite,
    otpshab,
    verifyshab,
    otpjabama,
    verifyjabama,
    otpotaghak,
    verifyotaghak,
    otpjajiga, reservesite,
    verifyjajiga, checkcode, otpmihmansho, verifymihmansho, disconnect
} from '../../../../../api/api'
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ProductListItem2 from "../../../../../components/eCommerce/ProductListItem2";
import InfiniteScroll from "react-infinite-scroll-component";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Switch from "@material-ui/core/Switch";
import {TelegramIcon, TelegramShareButton, WhatsappIcon, WhatsappShareButton} from "react-share";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from '@material-ui/core/DialogContent';
import Divider from "@material-ui/core/Divider";
import IntlMessages from "../../../../../util/IntlMessages";
import {hideAuthLoader, saveUpdate, showAuthLoader} from "../../../../../actions";
import cancelrequest from "assets/images/cancelrequest.png"
import reload from "assets/images/reload.png"
import check from "assets/images/check.png"
import share from "../../../../../assets/images/share.png";
import add from "../../../../../assets/images/addbutton.png";
import {useDispatch} from "react-redux";

var moment = require('moment-jalaali')
var persian = require('persian-date');


const useStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },

        '&.MuiIconButton-root': {

            padding: 2,

        },


    },

    border2: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        width: '100%',
        fontSize: 5,
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    bordererror: {
        fontFamily: 'iransans',
        border: '1px solid red',
        borderRadius: 10,
        fontSize: 5,
        width: '100%',
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },
    buttonfulllogin: {
        fontSize: 15,
        fontWeight: 'bold',
        height: 40,
        width: 160,
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3fb54f',
        '&:hover': {
            backgroundColor: '#0cec3c',
        },
    },
    buttonfull: {
        fontSize: 15,
        fontWeight: 'bold',
        height: 40,
        width: 160,
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#cd6a6a',
        '&:hover': {
            backgroundColor: '#ff0624',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',


        "&:hover": {
            cursor: 'pointer'
        },


    },

    borderselected: {
        fontFamily: 'iransans',
        border: '1px solid #152e84',
        borderRadius: 10,
        fontSize: 5,
        backgroundColor: '#152e84',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',

        "&:hover": {
            cursor: 'pointer'
        },

    },


    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    buttonProgress2: {
        color: green[500],
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },


    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    },
    margin: {

        width: 50,
        height: 25,
        textAlign: 'center'


    },
    textBox: {
        "& $div": {
            justifyContent: "center",
            "& $input": {
                width: "30%"
            }
        },
        "& $p": {
            alignSelf: "center"
        }
    },
    inputremove: {

        textAlign: 'center',


        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none'
        },


    }


}));

function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var ch = value.charCodeAt(i);
        if (ch >= 1776 && ch <= 1785) // For Persian digits.
        {
            var newChar = ch - 1728;
            newValue = newValue + String.fromCharCode(newChar);
        } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
        {
            var newChar = ch - 1584;
            newValue = newValue + String.fromCharCode(newChar);
        } else
            newValue = newValue + String.fromCharCode(ch);
    }
    return newValue;
};


var list;
let reserve = [];
let noreserve = [];
let reservemain = [];
let pricelist = [];
let start = "";
let end = "";
let price = "";
let addprice = "";
let single = true;
let today;
let startmonth;


function toPersianNum(num, dontTrim) {

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
            icon={<span className={classes.icon}/>}
            {...props}
        />
    );
}

const MySwal = withReactContent(Swal);
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

function checkMobile(mobile) {
    if (mobile.length == 0) return false;
    mobile = persianToEnglish(mobile);

    mobile = mobile.length == 10 ? "0" + mobile : mobile;

    if (mobile.length == 11) {
        return mobile.match(/9[01239]\d{8}/) ? true : false;
        // return mobile.match(/09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}/);
    } else {
        return false;
    }
}

const Sitelist = (props) => {

    const classes = useStyles();
    const [openalert, setOpenalert] = useState(false);
    const [loader, setLoader] = useState(true);
    const [loaderotp, setLoaderotp] = useState(false);
    const [loadersteptwo, setLoadersteptwo] = useState(true);
    const [otp, setOtp] = useState(false);
    const [otpname, setOtpname] = useState('');
    const [site, setSite] = useState('');
    const [mainlist, setMainlist] = useState([]);
    const [mainlisttwo, setMainlisttwo] = useState([]);
    const [alertMessage, setAlertMessage] = useState('');
    const [errorresponse, setErrorresponse] = useState(false);
    const [mobile, setMobile] = useState('');
    const [disable, setDisable] = useState(true);
    const [one, setOne] = useState(true);
    const [verifycode, setVerifycode] = useState(false);
    const [error, setError] = useState('شماره موبایل وارد شده صحیح نیست');
    const [codtaeed, setCodtaeed] = React.useState('');
    const [disablecodtaeed, setDisablecodtaeed] = useState(true);
    const [loading, setLoading] = useState(false);
    const [seconds, setSeconds] = useState(120);
    const [start, setStart] = useState(false);
    const [showresult, setShowresult] = useState(false);
    const [onestep, setOnestep] = useState(true);
    const [twostep, setTwostep] = useState(false);
    const [activelisteng, setActivelisteng] = React.useState('');
    const [otpconnect, setOtpconnect] = useState(false);
    const [showtry, setShowtry] = useState(false);
    const [loaderconnect, setLoaderconnect] = useState(false);
    const dispatch = useDispatch();
    debugger;

    const clickchangeprice = () => {
        // if (changeprice) {
        //     setChangeprice(false);
        // } else {
        //     setChangeprice(true);
        // }

        // start = "";
        // end = "";
        // reserve.length = 0;
        // pricelist.length = 0;
        // noreserve.length = 0;
        // setRender(!render)


    };

    useEffect(() => {


        if (start) {
            if (seconds > 0) {
                setTimeout(() => setSeconds(seconds - 1), 1000);
            } else {
                setStart(false);
                setSeconds(seconds);
            }
        } else {

        }


    });

    useEffect(() => {

        getlistsite();
        // console.log('homeid ' + props.homeid)

    }, []);


    const getlistsite = () => {

        getsite()
            .then((response) => {
                setMainlist(response.data.list)
                setLoader(false);
                let siteokeng = []
                for (var i = 0; i < response.data.list.length; i++) {
                    if (response.data.list[i].login === true) {
                        siteokeng.push(response.data.list[i].site);
                    }
                }
                if (siteokeng.length !== response.data.list.length) {
                    setShowtry(true);
                } else {
                    setShowtry(false);
                }
                setActivelisteng(siteokeng);
            })
            .catch((error) => {
                debugger;
                console.log(error)
            })


    };

    const openotp = (name, site) => {
        // alert(name);
        setOtpname(name);
        setSite(site);
        setMobile('');
        setCodtaeed('');
        setOne(true);
        setVerifycode(false);
        setOtp(true);
    };

    const openotpconnect = (name, site) => {
        setOtpname(name);
        setSite(site);
        setOtpconnect(true);
        // alert(name);
        // setOtpname(name);
        // setSite(site);
        // setMobile('');
        // setCodtaeed('');
        // setOne(true);
        // setVerifycode(false);
        // setOtp(true);
    };


    const onchangemobile = (e) => {
        setMobile(toPersianNum(e.target.value))
        console.log(e.target.value);
        if (checkMobile(e.target.value)) {
            // setValidatemobile(true);
            setDisable(false);
        } else {
            // setValidatemobile(false);
            setDisable(true);
        }
    };

    const onClickreload = () => {
        setLoader(true);
        setOnestep(false);
        setTwostep(true);


        const formData = new FormData();
        formData.append("homeid", props.homeid);
        formData.append("sites", activelisteng.toString());
        reservesite(formData)
            .then((response) => {
                debugger;
                if (response.data.errorCode === 0) {
                    setLoader(false);
                    setMainlisttwo(response.data.listresult)
                    setLoadersteptwo(false);
                    if (response.data.firststep === true) {
                        setOnestep(true);
                        setTwostep(false);
                    }
                } else {
                    debugger;
                }
                debugger;
                console.log(response)
            })
            .catch((error) => {
                debugger;
                console.log(error)
            });
    }

    const onClickshowtry = () => {
        setLoader(true)
        getlistsite();

    }

    const onClicknext = () => {

        if (activelisteng.length === 0) {
            Toast.fire({
                icon: 'error',
                title: 'لطفا حداقل به یکی از سایت ها متصل بشین'
            })
            return;
        }

        setOnestep(false);
        setTwostep(true);


        const formData = new FormData();
        formData.append("homeid", props.homeid);
        formData.append("sites", activelisteng.toString());
        reservesite(formData)
            .then((response) => {
                debugger;
                if (response.data.errorCode === 0) {
                    setMainlisttwo(response.data.listresult)
                    setLoadersteptwo(false);
                    if (response.data.firststep === true) {
                        setOnestep(true);
                        setTwostep(false);
                    }
                    dispatch(saveUpdate(Number(0)));
                    localStorage.setItem("update", Number(0));
                    setShowresult(true);
                } else {
                    setOnestep(true);
                    setTwostep(false);
                    setLoadersteptwo(false);
                    Toast.fire({
                        icon: 'error',
                        title: response.data.errorDescription
                    })
                }
                debugger;
                console.log(response)
            })
            .catch((error) => {
                debugger;
                console.log(error)
            });
    }
    const onClickfinish = () => {
        props.handleCloseChecksite();
    }


    const onClickone = () => {

        // if (disable) {
        //
        //
        // } else {
        //
        //     setLoading(true);
        //     setDisable(true);
        //
        //     // debugger;
        //     // Apitest2()
        //     //     .then((response) => {
        //     //
        //     //         console.log(response)
        //     //     })
        //     //     .catch((error) => {
        //     //
        //     //         console.log(error)
        //     //     })
        //     //
        //     // debugger;
        //     signinn(mobile, password);
        //
        //
        //     // dispatch(showAuthLoader());
        //     // dispatch(userSignIn({email, password}));
        //
        //     setTimeout(() => {
        //
        //         setLoading(false);
        //         setDisable(false);
        //         setOne(false);
        //         setTwo(true);
        //         NotificationManager.error("نام کاربری و رمز را وارد کنید")
        //
        //     }, 2000);
        // }

        // alert(props.from);

        if (disable) {


        } else {

            // setLoading(true);

            if (checkMobile(mobile)) {
                setDisable(true);
                setLoaderotp(true);


                if (site === 'mihmansho') {
                    const formData = new FormData();
                    formData.append("mobile", persianToEnglish(mobile));
                    otpmihmansho(formData)
                        .then((response) => {
                            debugger;
                            if (response.data.errorCode === 0) {
                                setVerifycode(true);
                                setOne(false);
                                setLoaderotp(false);
                            } else {
                                debugger;
                            }
                            debugger;
                            console.log(response)
                        })
                        .catch((error) => {
                            debugger;
                            console.log(error)
                        });
                }
                if (site === 'shab') {
                    const formData = new FormData();
                    formData.append("mobile", persianToEnglish(mobile));
                    otpshab(formData)
                        .then((response) => {
                            debugger;
                            if (response.data.errorCode === 0) {
                                setVerifycode(true);
                                setOne(false);
                                setLoaderotp(false);
                            } else {
                                debugger;
                            }
                            debugger;
                            console.log(response)
                        })
                        .catch((error) => {
                            debugger;
                            console.log(error)
                        });
                }
                if (site === 'jabama') {
                    const formData = new FormData();
                    formData.append("mobile", persianToEnglish(mobile));
                    otpjabama(formData)
                        .then((response) => {
                            debugger;
                            if (response.data.errorCode === 0) {
                                setVerifycode(true);
                                setOne(false);
                                setLoaderotp(false);
                            } else {
                                debugger;
                            }
                            debugger;
                            console.log(response)
                        })
                        .catch((error) => {
                            debugger;
                            console.log(error)
                        });
                }
                if (site === 'otaghak') {
                    const formData = new FormData();
                    formData.append("mobile", persianToEnglish(mobile));
                    otpotaghak(formData)
                        .then((response) => {
                            debugger;
                            if (response.data.errorCode === 0) {
                                setVerifycode(true);
                                setOne(false);
                                setLoaderotp(false);
                            } else {
                                debugger;
                            }
                            debugger;
                            console.log(response)
                        })
                        .catch((error) => {
                            debugger;
                            console.log(error)
                        });
                }
                if (site === 'jajiga') {
                    const formData = new FormData();
                    formData.append("mobile", persianToEnglish(mobile));
                    otpjajiga(formData)
                        .then((response) => {
                            debugger;
                            if (response.data.errorCode === 0) {
                                setVerifycode(true);
                                setOne(false);
                                setLoaderotp(false);
                            } else {
                                debugger;
                            }
                            debugger;
                            console.log(response)
                        })
                        .catch((error) => {
                            debugger;
                            console.log(error)
                        });
                }

            }
        }
    };

    const onClicksend = () => {
        checkcodefunc(mobile, persianToEnglish(codtaeed));
    }

    const onchangecodtaeed = (e) => {
        setCodtaeed(toPersianNum(e.target.value));
        if (site === 'mihmansho') {
            if (e.target.value.length === 5) {
                setLoaderotp(true);
                setDisablecodtaeed(false);
                setLoading(true);
                checkcodefunc(mobile, persianToEnglish(e.target.value));
            } else {
                setDisablecodtaeed(true);
            }
        } else {
            if (e.target.value.length === 4) {
                setLoaderotp(true);
                setDisablecodtaeed(false);
                setLoading(true);
                checkcodefunc(mobile, persianToEnglish(e.target.value));
            } else {
                setDisablecodtaeed(true);
            }
        }

    };

    const checkcodefunc = (mobile, code) => {
        if (site === 'mihmansho') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            formData.append("code", persianToEnglish(code));
            verifymihmansho(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setOtp(false);
                        setLoaderotp(false);
                        getlistsite();
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'shab') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            formData.append("code", persianToEnglish(code));
            verifyshab(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setOtp(false);
                        setLoaderotp(false);
                        getlistsite();
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'jabama') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            formData.append("code", persianToEnglish(code));
            verifyjabama(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setOtp(false);
                        setLoaderotp(false);
                        getlistsite();
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'otaghak') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            formData.append("code", persianToEnglish(code));
            verifyotaghak(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setOtp(false);
                        setLoaderotp(false);
                        getlistsite();
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'jajiga') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            formData.append("code", persianToEnglish(code));
            verifyjajiga(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setOtp(false);
                        setLoaderotp(false);
                        getlistsite();
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
    };

    const onClickresend = () => {

        resendfunc()

    }

    const onClickdisconnect = () => {
        setLoaderconnect(true)
        const formData = new FormData();
        formData.append("site", site);
        disconnect(formData)
            .then((response) => {
                debugger;
                if (response.data.errorCode === 0) {
                    setOtpconnect(false);
                    setLoaderconnect(false);
                    getlistsite();
                } else {
                    debugger;
                }
                debugger;
                console.log(response)
            })
            .catch((error) => {
                debugger;
                console.log(error)
            });


    }

    const onClickeditnumber = () => {
        setOne(true);
        setVerifycode(false);
    }

    const resendfunc = () => {
        setOne(true);
        setVerifycode(false);
        setDisable(true);
        setLoader(true);

        if (site === 'shab') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            otpshab(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setVerifycode(true);
                        setOne(false);
                        setLoader(false);
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'jabama') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            otpjabama(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setVerifycode(true);
                        setOne(false);
                        setLoader(false);
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'otaghak') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            otpotaghak(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setVerifycode(true);
                        setOne(false);
                        setLoader(false);
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }
        if (site === 'jajiga') {
            const formData = new FormData();
            formData.append("mobile", persianToEnglish(mobile));
            otpjajiga(formData)
                .then((response) => {
                    debugger;
                    if (response.data.errorCode === 0) {
                        setVerifycode(true);
                        setOne(false);
                        setLoader(false);
                    } else {
                        debugger;
                    }
                    debugger;
                    console.log(response)
                })
                .catch((error) => {
                    debugger;
                    console.log(error)
                });
        }

    }

    return (

        <div className="d-flex flex-column" style={{width: '100%'}}>

            {loader ?
                <CircularProgress size={24} className={classes.buttonProgress}/>
                :
                <div>
                    {onestep ?
                        <div>
                            {mainlist.map((i, index) => (

                                <div style={{
                                    display: 'flex', justifyContent: 'space-between',
                                    alignItems: 'center', width: '100%', marginTop: 20
                                }}>

                                    <div style={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        fontFamily: 'iransans',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        padding: 0
                                    }}>
                                        <div style={{fontSize: 22, fontWeight: 'bold'}}>{mainlist[index].sitename}</div>
                                    </div>


                                    {mainlist[index].error === "timeout" ?
                                        <Button
                                            style={{
                                                color: "#ffffff",
                                                fontFamily: 'iransans',
                                                fontWeight: 'bold'
                                            }}
                                            className={classes.buttonfull}
                                            variant="outlined"
                                        >
                                            ..TimeOut
                                        </Button>
                                        :

                                        <div>
                                            {mainlist[index].login ?
                                                <Button
                                                    onClick={() => openotpconnect(mainlist[index].sitename, mainlist[index].site)}
                                                    style={{
                                                        color: "#ffffff",
                                                        fontFamily: 'iransans',
                                                        fontWeight: 'bold'
                                                    }}
                                                    className={classes.buttonfulllogin}
                                                    variant="outlined"
                                                >
                                                    متصل است
                                                </Button>
                                                :
                                                <div>
                                                    {mainlist[index].statuscode === 401 ?
                                                        <Button
                                                            onClick={() => openotp(mainlist[index].sitename, mainlist[index].site)}
                                                            style={{
                                                                color: "#ffffff",
                                                                fontFamily: 'iransans',
                                                                fontWeight: 'bold'
                                                            }}
                                                            className={classes.buttonfull}
                                                            variant="outlined"
                                                        >
                                                            مشکل احراز هویت
                                                        </Button>
                                                        :
                                                        <Button
                                                            onClick={() => openotp(mainlist[index].sitename, mainlist[index].site)}
                                                            style={{
                                                                color: "#ffffff",
                                                                fontFamily: 'iransans',
                                                                fontWeight: 'bold'
                                                            }}
                                                            className={classes.buttonfull}
                                                            variant="outlined"
                                                        >
                                                            مشکل سایت مقصد
                                                        </Button>
                                                    }
                                                </div>

                                            }
                                        </div>


                                    }


                                </div>
                            ))}
                        </div>
                        :
                        null
                    }
                    {twostep ?
                        <div>
                            {loadersteptwo ?
                                <CircularProgress size={24} className={classes.buttonProgress}/>

                                :
                                <div>

                                    {showresult ?
                                        <div style={{
                                            display: 'flex',
                                            marginTop: 20,
                                            fontSize: 15,
                                            fontFamily: 'iransans',
                                            fontWeight: 'bold'
                                        }}>
                                            <div>نتیجه به روز رسانی :</div>
                                            {/*<div style={{marginRight: 5}}> {Name} - {Code} </div>*/}
                                        </div>
                                        :
                                        null
                                    }

                                    <div>
                                        {mainlisttwo.map((i, index) => (

                                            <div style={{
                                                display: 'flex', justifyContent: 'space-between',
                                                alignItems: 'center', width: '100%', marginTop: 20
                                            }}>

                                                <div style={{
                                                    justifyContent: 'center',
                                                    display: 'flex',
                                                    fontFamily: 'iransans',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    padding: 0
                                                }}>
                                                    <div style={{
                                                        fontSize: 22,
                                                        fontWeight: 'bold'
                                                    }}>{mainlisttwo[index].sitename}</div>
                                                    {mainlisttwo[index].result ?
                                                        // <CircularProgress size={24} className={classes.buttonProgress}/>
                                                        null
                                                        :
                                                        // <img src={reload} style={{width: 25, height: 25, marginRight: 8}}></img>
                                                        <Button style={{marginRight: 8, backgroundColor: '#00cdff'}}
                                                                onClick={onClickreload}
                                                                variant="contained"
                                                                className="text-white iran-font">
                                                            <div>
                                                                <img src={reload}
                                                                     style={{
                                                                         width: 20,
                                                                         marginLeft: 10,
                                                                         height: 20
                                                                     }}></img>
                                                            </div>
                                                            <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                                                تلاش مجدد
                                                            </div>
                                                        </Button>
                                                    }
                                                </div>
                                                {mainlisttwo[index].result ?
                                                    <img src={check} style={{width: 25, height: 25}}></img>
                                                    :
                                                    <div>
                                                        <img src={cancelrequest} style={{width: 25, height: 25}}></img>
                                                    </div>
                                                }
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            }
                        </div>
                        :
                        null
                    }
                    {onestep ?
                        <div className="d-flex align-items-center"
                             style={{position: "absolute", bottom: 0, width: '100%', paddingLeft: 10}}>
                            <Button onClick={onClicknext} disabled={loader} variant="contained" color="primary" style={{
                                width: 200,
                                height: 50,
                                marginLeft: 5,
                                marginTop: 15,
                                marginBottom: 15,
                                cursor: 'pointer',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px solid ',
                                // backgroundColor: '#bb5eb4',
                                backgroundColor: '#152e84',
                                borderColor: '#152e84',
                                borderRadius: 10,
                            }} className="iran-font">
                                <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>ادامه</div>
                                {loader &&
                                <CircularProgress size={24} className={classes.buttonProgress}/>}
                            </Button>

                            {showtry ?
                                <Button onClick={onClickshowtry} disabled={loader} variant="contained" color="primary"
                                        style={{
                                            width: 200,
                                            height: 50,
                                            marginLeft: 5,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            cursor: 'pointer',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                            // backgroundColor: '#bb5eb4',
                                            backgroundColor: '#dc3245',
                                            borderColor: '#dc3245',
                                            borderRadius: 10,
                                        }} className="iran-font">
                                    <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>تلاش دوباره</div>
                                    {loader &&
                                    <CircularProgress size={24} className={classes.buttonProgress}/>}
                                </Button>

                                :
                                null

                            }

                        </div>
                        :
                        null
                    }
                    {twostep ?
                        <div className="d-flex align-items-center"
                             style={{position: "absolute", bottom: 0, width: '100%', paddingLeft: 10}}>
                            <Button onClick={onClickfinish} disabled={loader} variant="contained" color="primary"
                                    style={{
                                        width: 200,
                                        height: 50,
                                        marginLeft: 5,
                                        marginTop: 15,
                                        marginBottom: 15,
                                        cursor: 'pointer',
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '1px solid ',
                                        // backgroundColor: '#bb5eb4',
                                        backgroundColor: '#152e84',
                                        borderColor: '#152e84',
                                        borderRadius: 10,
                                    }} className="iran-font">
                                <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>بستن</div>
                                {loader &&
                                <CircularProgress size={24} className={classes.buttonProgress}/>}
                            </Button>
                        </div>
                        :
                        null
                    }

                </div>

            }

            <Snackbar open={openalert} autoHideDuration={3000} onClose={() => setOpenalert(false)}>
                <Alert style={{fontFamily: 'iransans'}} severity="error">
                    {alertMessage}
                </Alert>
            </Snackbar>

            <Dialog onClose={() => setOtp(false)} aria-labelledby="customized-dialog-title" open={otp}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>
                    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                        ورود در {otpname}
                    </div>
                    <IconButton onClick={() => setOtp(false)} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>

                <DialogContent dividers>
                    <div>
                        <div className="col-12 mb-3" style={{
                            display: 'flex', flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                            {one ?
                                <div style={{
                                    display: 'flex', flexDirection: 'row', justifyContent: 'center',
                                    alignItems: 'center', marginLeft: 20, fontFamily: 'iransans', fontWeight: 'bold',
                                }}>شماره تماس خود را که با آن در سایت {otpname} ثبت نام کرده اید را وارد کنید
                                </div>
                                :
                                null
                            }

                            {verifycode ?
                                <div style={{
                                    display: 'flex', flexDirection: 'row', justifyContent: 'center',
                                    alignItems: 'center', marginLeft: 20, fontFamily: 'iransans', fontWeight: 'bold',
                                }}>یک کد از طرف سایت {otpname} برای شما ارسال شده است , لطفا آن را وارد کنید
                                </div>
                                :
                                null
                            }


                        </div>


                        <div style={{
                            display: 'flex', justifyContent: 'center', flexDirection: 'row',
                            paddingRight: 10, paddingLeft: 10, paddingBottom: 10,
                            alignItems: 'center', width: '100%', marginBottom: 10
                        }}>

                            <div style={{marginTop: 30}}>

                                {one ?
                                    <div
                                        className={`${errorresponse ? classes.bordererror : classes.border2}`}>

                                        <div style={{
                                            fontSize: 15,
                                            direction: 'ltr',
                                            display: 'inline-block', fontWeight: 'bold',
                                            marginRight: 10
                                        }}>+۹۸
                                        </div>

                                        <Divider orientation="vertical" flexItem/>


                                        <input type="text" pattern="[0-9]*" value={mobile}
                                            // onKeyPress={e => onKeyPressHandlerone(e)}
                                               className={`place-holder-right ${classes.inputremove}`}
                                               style={{
                                                   width: '100%',
                                                   border: 'none !important',
                                                   fontSize: 20, fontWeight: 'bold',
                                                   marginLeft: 5,
                                                   direction: 'LTR',
                                                   backgroundColor: '#fff',
                                                   borderWidth: 0,

                                                   boxShadow: 'none'
                                               }} placeholder="شماره موبایل"
                                               onChange={e => onchangemobile(e)}>


                                        </input>

                                    </div>
                                    :
                                    null
                                }
                                {verifycode ?
                                    <div>

                                        <div style={{
                                            display: 'flex',
                                            direction: 'ltr',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start'
                                        }}>
                                            <div
                                                className={`${errorresponse ? classes.bordererror : classes.border}`}>

                                                <input type="text" pattern="[0-9]*" value={codtaeed}
                                                       className={`place-holder-center ${classes.inputremove}`}
                                                       style={{
                                                           width: '100%',
                                                           border: 'none !important',
                                                           fontSize: 20, fontWeight: 'bold',
                                                           direction: 'LTR',
                                                           backgroundColor: '#fff',
                                                           borderWidth: 0,
                                                           textAlign: 'center',
                                                           boxShadow: 'none'
                                                       }} placeholder="کد تایید را وارد کنید"
                                                       onChange={e => onchangecodtaeed(e)}>


                                                </input>

                                            </div>


                                        </div>


                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start'
                                        }}>

                                            <span style={{marginTop: 10, fontSize: 11, color: '#000'}}
                                                  className={classes.oncepassword}
                                                  onClick={onClickeditnumber}
                                            >ویرایش شماره موبایل</span>

                                            {start ?

                                                <div style={{marginTop: 10}}>
                                                    {toPersianNum(seconds)} ثانیه
                                                </div>

                                                :
                                                <div onClick={onClickresend}
                                                     className={classes.oncepassword}
                                                     style={{marginTop: 10, fontSize: 11, color: '#000'}}>
                                                    ارسال دوباره کد
                                                </div>

                                            }


                                        </div>


                                    </div>
                                    :
                                    null
                                }
                                {one ?
                                    <div className="mb-3 d-flex align-items-center justify-content-between"
                                         style={{marginTop: 50, flexDirection: 'row-reverse'}}>
                                        {/*<Button onClick={() => {*/}
                                        {/*dispatch(showAuthLoader());*/}
                                        {/*dispatch(userSignIn({email, password}));*/}
                                        {/*}} variant="contained" color="primary" className="iran-font">*/}
                                        {/*<IntlMessages id="appModule.nextstep"/>*/}
                                        {/*</Button>*/}


                                        <Button onClick={onClickone} fullWidth={true} variant="contained"
                                                color="primary"
                                                disabled={disable} style={{fontWeight: 'bold', height: 40}}
                                                className="iran-font">
                                            <IntlMessages id="appModule.edame"/>
                                            {loaderotp &&
                                            <CircularProgress size={24}
                                                              className={classes.buttonProgress}/>}
                                        </Button>


                                        {/*<Link to="/signup">*/}
                                        {/*<IntlMessages id="signIn.signUp"/>*/}
                                        {/*</Link>*/}
                                    </div>
                                    :
                                    null
                                }
                                {verifycode ?
                                    <div className="mb-3 d-flex align-items-center justify-content-between"
                                         style={{marginTop: 50, flexDirection: 'row-reverse'}}>
                                        {/*<Button onClick={() => {*/}
                                        {/*dispatch(showAuthLoader());*/}
                                        {/*dispatch(userSignIn({email, password}));*/}
                                        {/*}} variant="contained" color="primary" className="iran-font">*/}
                                        {/*<IntlMessages id="appModule.nextstep"/>*/}
                                        {/*</Button>*/}


                                        <Button onClick={onClicksend} fullWidth={true} variant="contained"
                                                color="primary"
                                                disabled={disablecodtaeed} style={{fontWeight: 'bold', height: 40}}
                                                className="iran-font">
                                            <div>ارسال</div>
                                            {loaderotp &&
                                            <CircularProgress size={24}
                                                              className={classes.buttonProgress}/>}
                                        </Button>


                                        {/*<Link to="/signup">*/}
                                        {/*<IntlMessages id="signIn.signUp"/>*/}
                                        {/*</Link>*/}
                                    </div>
                                    :
                                    null
                                }


                                {errorresponse ?

                                    <div className={classes.error}>
                                        {error}
                                    </div>
                                    :
                                    null

                                }


                            </div>
                            {/*<div className="d-flex align-items-center justify-content-center" style={{width: 150}}>*/}
                            {/*    <WhatsappShareButton url="asdasd">*/}
                            {/*        <WhatsappIcon size={40} round={true}/>*/}
                            {/*        <div style={{marginRight: 10, fontWeight: 'bold', fontFamily: 'iransans'}}>*/}
                            {/*            واتس آپ*/}
                            {/*        </div>*/}
                            {/*    </WhatsappShareButton>*/}
                            {/*</div>*/}
                            {/*<div className="d-flex align-items-center justify-content-center" style={{width: 150}}>*/}
                            {/*    <TelegramShareButton url="asdasd">*/}
                            {/*        <TelegramIcon size={40} round={true}/>*/}
                            {/*        <div style={{marginRight: 10, fontWeight: 'bold', fontFamily: 'iransans'}}>*/}
                            {/*            تلگرام*/}
                            {/*        </div>*/}
                            {/*    </TelegramShareButton>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog onClose={() => setOtpconnect(false)} aria-labelledby="customized-dialog-title" open={otpconnect}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>
                    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                        ورود در {otpname}
                    </div>
                    <IconButton onClick={() => setOtpconnect(false)} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>

                <DialogContent dividers>
                    <div>
                        <div className="col-12 mb-3" style={{
                            display: 'flex', flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                            <img
                                src={check}
                                style={{
                                    width: 20, height: 20, cursor: 'pointer', marginLeft: 5
                                }}
                            />
                            <div style={{
                                display: 'flex', flexDirection: 'row', justifyContent: 'center',
                                alignItems: 'center', marginLeft: 20, fontFamily: 'iransans', fontWeight: 'bold',
                            }}>
                                شما در سایت {otpname} متصل هستید . برای قطع اتصال دکمه زیر را بزنید
                            </div>
                        </div>


                        <div style={{
                            display: 'flex', justifyContent: 'center', flexDirection: 'row',
                            paddingRight: 10, paddingLeft: 10, paddingBottom: 10,
                            alignItems: 'center', width: '100%', marginBottom: 10
                        }}>

                            <div style={{marginTop: 30}}>

                                {/*{one ?*/}
                                {/*    <div*/}
                                {/*        className={`${errorresponse ? classes.bordererror : classes.border2}`}>*/}

                                {/*        <div style={{*/}
                                {/*            fontSize: 15,*/}
                                {/*            direction: 'ltr',*/}
                                {/*            display: 'inline-block', fontWeight: 'bold',*/}
                                {/*            marginRight: 10*/}
                                {/*        }}>+۹۸*/}
                                {/*        </div>*/}

                                {/*        <Divider orientation="vertical" flexItem/>*/}


                                {/*        <input type="text" pattern="[0-9]*" value={mobile}*/}
                                {/*            // onKeyPress={e => onKeyPressHandlerone(e)}*/}
                                {/*               className={`place-holder-right ${classes.inputremove}`}*/}
                                {/*               style={{*/}
                                {/*                   width: '100%',*/}
                                {/*                   border: 'none !important',*/}
                                {/*                   fontSize: 20, fontWeight: 'bold',*/}
                                {/*                   marginLeft: 5,*/}
                                {/*                   direction: 'LTR',*/}
                                {/*                   backgroundColor: '#fff',*/}
                                {/*                   borderWidth: 0,*/}

                                {/*                   boxShadow: 'none'*/}
                                {/*               }} placeholder="شماره موبایل"*/}
                                {/*               onChange={e => onchangemobile(e)}>*/}


                                {/*        </input>*/}

                                {/*    </div>*/}
                                {/*    :*/}
                                {/*    null*/}
                                {/*}*/}

                                <div className="mb-3 d-flex align-items-center justify-content-between"
                                     style={{marginTop: 20, width: 250, flexDirection: 'row-reverse'}}>
                                    {/*<Button onClick={() => {*/}
                                    {/*dispatch(showAuthLoader());*/}
                                    {/*dispatch(userSignIn({email, password}));*/}
                                    {/*}} variant="contained" color="primary" className="iran-font">*/}
                                    {/*<IntlMessages id="appModule.nextstep"/>*/}
                                    {/*</Button>*/}


                                    <Button onClick={onClickdisconnect} fullWidth={true} variant="contained"
                                            color="primary"
                                            style={{fontWeight: 'bold', height: 40}}
                                            className="iran-font">
                                        <div>قطع اتصال</div>
                                        {loaderconnect &&
                                        <CircularProgress size={24}
                                                          className={classes.buttonProgress}/>}
                                    </Button>


                                    {/*<Link to="/signup">*/}
                                    {/*<IntlMessages id="signIn.signUp"/>*/}
                                    {/*</Link>*/}
                                </div>

                                {errorresponse ?

                                    <div className={classes.error}>
                                        {error}
                                    </div>
                                    :
                                    null

                                }


                            </div>
                            {/*<div className="d-flex align-items-center justify-content-center" style={{width: 150}}>*/}
                            {/*    <WhatsappShareButton url="asdasd">*/}
                            {/*        <WhatsappIcon size={40} round={true}/>*/}
                            {/*        <div style={{marginRight: 10, fontWeight: 'bold', fontFamily: 'iransans'}}>*/}
                            {/*            واتس آپ*/}
                            {/*        </div>*/}
                            {/*    </WhatsappShareButton>*/}
                            {/*</div>*/}
                            {/*<div className="d-flex align-items-center justify-content-center" style={{width: 150}}>*/}
                            {/*    <TelegramShareButton url="asdasd">*/}
                            {/*        <TelegramIcon size={40} round={true}/>*/}
                            {/*        <div style={{marginRight: 10, fontWeight: 'bold', fontFamily: 'iransans'}}>*/}
                            {/*            تلگرام*/}
                            {/*        </div>*/}
                            {/*    </TelegramShareButton>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>


        </div>


    );

}
;


export default Sitelist;
